export default {

    audit: {
        history: "Historie",

        report: {
            title     : "Reports",
            comparison: "Soll-/Ist-Abgleich",
            adaptation: "Konzept zur Anpassung",
            estimation: "Kostenschätzung",
            assessment: "Gefährdungsbeurteilung",
            rebuild   : "Berichte neu erstellen",
            esg: "ESG Report"
        },

        costs: {
            label: "Schätzkosten",
            rule : "Standard Schätzkosten"
        },

        delta: {
            title: "Änderungen an {0} vom {1}",
            label: "Audit",
        } ,

        recalc: {
            title: "Rechner",
            budget: {
                title: "Schätzkosten neu berechnen",
                query: "Schätzkosten neu berechnen",
                text: "Mit <b>JA</b> werden die Schätzkosten der GBU neu berechnet. Alle bisherigen Schätzwerte werden dabei überschrieben."
            }
        },

        rebuild: {
            query: "Berichte neu erstellen?",
            text : "Mit <b>BERICHTE ERSTELLEN</b> werden alle GBU Berichte der Anlage neu erstellt und im Dokumentenorder <b>TZB + GBU</b> der Anlage ersetzt.",
            recalculate: "Mit dem Schalter <b>Schätzwerte neu berechnen</b> können die Schätzwerte für die GBU Budgetierung erneut berechnet werden",
            success: "Die Reports wurden neu erstellt.",
            label: "Schätzwerte neu berechnen"
        },

        edit: {
            saved: ""
        },

        // GBU type and escalator GBU (HCIT-917)
        type: {
            ELEVATOR : "Aufzug",
            ESCALATOR: "Fahrtreppe",
        },

        escalator: {
            missingCatalogue: "Der Fahrtreppen-Katalog konnte nicht geladen werden. Bitte die Seite neu laden.",
            measures        : "Maßnahmen",
            risk            : "Risiko",
            frequence       : "Häufigkeit",
            weight          : "Schwere",
            chosen          : "gewählt",
            notChosen       : "nicht gewählt",
            deleted         : "gelöscht",
            done            : "Maßnahme umgesetzt",
            note            : "Notiz",
            edit            : "Notiz bearbeiten",
            save            : "Änderungen speichern",
            cancel          : "Bearbeitung ohne speichern beenden",

            kind: {
                DEFAULT           : "Standard",
                OPTIONAL          : "optional",
                DEFAULT_INADEQUATE: "Standard bei Unzulänglich",
            },
        },
    }
}